<div [ngClass]="{ disabled: isSyncing, 'list-wrapper': true }">
  <div class="flex flex-col w-full">
    <!-- Mail list header -->
    <div [ngClass]="{ header: true, hidden: isDealView() }">
      <!-- Header left -->
      <div class="left">
        <!-- Category name -->
        <div class="category">Emails</div>
      </div>

      <!-- Pagination -->
      <div class="pagination"></div>

      <!-- Loading bar -->
      <mat-progress-bar class="loading-progress-bar" *ngIf="mailsLoading" [mode]="'indeterminate'"> </mat-progress-bar>
    </div>
    <ng-container>
      <!-- Mail list -->
      <div class="list" #mailList *ngIf="mails?.length; else noMails">
        <!-- Mail list item loop -->
        <ng-container *ngFor="let mail of mails; let i = index; trackBy: trackByFn">
          <!-- Mail list item -->
          <a class="item" (click)="viewEmail(mail)">
            <div class="item-content">
              <!-- Info -->
              <div class="info">
                <!-- Sender name -->
                <div class="name">
                  <span *ngIf="mail.data?.from">{{
                    mail.data.from[0]?.name ? mail.data.from[0].name.trim() : mail.data.from[0].trim()
                  }}</span>
                </div>

                <!-- Delete email -->
                <button class="delete-button" mat-icon-button (click)="onDeleteEmail($event, mail)">
                  <mat-icon [svgIcon]="'delete'"></mat-icon>
                </button>
              </div>

              <!-- Subject -->
              <div class="subject">
                <span>{{ mail.data?.subject }}</span>

                <!-- Indicators -->
                <div class="indicators">
                  <!-- Attachments indicator -->
                  <mat-icon *ngIf="mail.file_resources?.length" class="attachments-indicator" [svgIcon]="'attachment'">
                  </mat-icon>

                  <!-- Date -->
                  <div class="date">
                    {{ mail.received_at | date: 'LLL dd, y' }}
                  </div>
                </div>
              </div>

              <!-- Excerpt -->
              <div class="excerpt">
                {{ mail.data?.body_preview | slice: 0 : 80 }}
                <ng-container *ngIf="mail.data?.body_preview?.length > 80">... </ng-container>
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #noMails>
      <div class="py-8" [ngClass]="{ 'no-mails': true, 'bg-white': isDealView() }">
        <mat-icon class="icon-size-40" [svgIcon]="'iconsmind:mailbox_empty'"></mat-icon>
        <p class="text-2xl text-secondary font-medium mt-4">There are no e-mails</p>
      </div>
    </ng-template>
  </div>
</div>
